import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FinancialYearUtilsService {

  /**
   * Returns financial year start & end dates (April 1 → March 31)
   * e.g., for "2025-2026", returns:
   *  start: 2025-04-01
   *  end:   2026-03-31
   */
  getFinancialYearRange(financialYear: string): { start: Date; end: Date } | null {
    if (!financialYear || typeof financialYear !== 'string') return null;

    const [startStr, endStr] = financialYear.split('-').map(s => s.trim());
    const startYear = parseInt(startStr, 10);
    const endYear = parseInt(endStr, 10);

    if (isNaN(startYear) || isNaN(endYear)) return null;

    // ✅ Convert into real Date objects
    const start = new Date(startYear, 3, 1);  // April 1
    const end = new Date(endYear, 2, 31);     // March 31

    return { start, end };
  }

  /**
   * Optional utility: auto detect current FY based on today's date
   */
  getCurrentFinancialYear(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // 0 = Jan, 3 = April
    return month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
  }
}


